import { Icon } from "@blueprintjs/core";
import { Link } from "react-router";

import { getStartPageURL } from "@/components/helpers/url-utils";
import { Container } from "@/components/pieces/bootstrap";
import { FiveStars } from "@/components/pieces/marketing/FiveStars";
import { InPartnership } from "@/components/pieces/marketing/InPartnership";
import { TypingEffect } from "@/components/pieces/TypingEffect";
import { Button } from "@/components/ui/button";
import {
  MAINTEXT_COLOR,
  MIDTEXT_COLOR,
  PUBLIC_CONTENT_MAX_WIDTH,
  STANDARD_NAV_HEIGHT,
} from "@/css/constants";

const HEADLINE_PHRASES = [
  "Sales training",
  "Leadership development",
  "Manager training",
  "Employee onboarding",
  "Change management",
];

export function MainHero() {
  return (
    <div
      className="md:pb-pt-20 bg-white pt-8 pb-20 md:pt-20"
      style={{ marginTop: STANDARD_NAV_HEIGHT }}
    >
      <Container maxWidth={PUBLIC_CONTENT_MAX_WIDTH} textAlign="center">
        <InPartnership />
        <h1 className="font-serif text-4xl/tight font-light text-gray-800 md:text-7xl/tight">
          <TypingEffect
            items={HEADLINE_PHRASES}
            typingSpeed={50}
            deletingSpeed={50}
            delayAfterType={2500}
          />
          <div>
            <i>that actually sticks</i>
          </div>
        </h1>
        <div
          className="mx-auto mt-6 max-w-2xl text-xl md:text-2xl"
          style={{ color: MAINTEXT_COLOR }}
        >
          One platform combining AI practice and expert coaching to deliver
          measurable skill development
        </div>
        <div
          className="mx-auto mt-9 inline-flex"
          style={{ color: MIDTEXT_COLOR }}
        >
          <FiveStars color="#F9452D" />
          <div>4.8 on G2</div>
        </div>
        <div className="mx-auto mt-9 flex w-full max-w-3xs flex-col items-center justify-center gap-4 sm:flex-row">
          <Button size="lg" className="w-full" asChild>
            <Link to="/demo">
              Book a Demo
              <Icon icon="arrow-right" />
            </Link>
          </Button>
          <Button variant="outline" size="lg" className="w-full" asChild>
            <Link to={getStartPageURL("?nextPath=/dashboard")}>Sign Up</Link>
          </Button>
        </div>
      </Container>
    </div>
  );
}
